import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext) || {};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      setSettings({});
    }
  };

  useEffect(() => { load(); }, []);

  const waLink = (msg) => {
    const num = (settings?.whatsapp || "").replace(/[^0-9]/g, "");
    return `https://wa.me/${num}?text=${encodeURIComponent(msg || "Hi, I'm interested in your properties.")}`;
  };
  const telLink = () => `tel:${settings?.phone || ""}`;

  return (
    <SettingsContext.Provider value={{ settings, reload: load, waLink, telLink }}>
      {children}
    </SettingsContext.Provider>
  );
}
